let transactionInvoicesSelector = $('#data-side-panel-transaction-invoice-selector');

if (transactionInvoicesSelector.length) {
    transactionInvoicesSelector
        .bind('nc.sidePanel.shown', function (e) {
            registerSelect(window.sidePanels.getCurrentSidePanel());
        })
        .bind('nc.sidePanel.reloaded', function (e) {
            registerSelect(window.sidePanels.getCurrentSidePanel());
        });

    function registerSelect(sidePanel) {
        sidePanel.content.find('tbody tr').click((e) => {
            if ($(e.target).closest('a').length > 0) {
                return;
            }

            let row = $(e.target).closest('tr');
            let number = row.find('td[data-column="invoice_number"]').text().trim()

            confirm('Wilt u zeker dat u factuur "' + number + '" wil koppelen?', () => {
                let form = sidePanel.content.find('form#link-invoice');
                form.find('input[type="hidden"][name="invoice_id"]')
                    .val(row.data('primary-key'))
                    .trigger('change');
                form.submit();
            }, () => {
                sidePanel.loader.close()
            })
        });
    }

}
